import { AreaOfExpertise, User } from '../../../types/user';
import { Detaljeringssteg } from '../../../types/registration/userInput';
import { DetailingStep } from '../../../components/registering/utils/registerEnums';
import { RegistrationCommonStep } from '../../../utils/navigation';

/** Same condition as showing the "Justering av verdier" (`parameter`) wizard step. */
export const userHasBygningsekspertRole = (user?: User): boolean =>
  user?.fagomrader?.includes(AreaOfExpertise.BYGNINGSEKSPERT) ?? false;

export const getV2025Steps = (user?: User, detaljeringssteg?: Detaljeringssteg) => {
  const steps: (DetailingStep | RegistrationCommonStep)[] = [];

  // About, ventilation, heating and detailing are required steps for all users
  steps.push(
    RegistrationCommonStep.ABOUT,
    RegistrationCommonStep.VENTILATION,
    RegistrationCommonStep.HEATING,
    RegistrationCommonStep.DETAIILING
  );

  // Add optional steps based on detaljeringssteg selection by user
  detaljeringssteg?.bygningsform && steps.push(DetailingStep.Bygningsform);
  detaljeringssteg?.vegger && steps.push(DetailingStep.Vegger);
  detaljeringssteg?.vinduer && steps.push(DetailingStep.Vinduer);
  detaljeringssteg?.takkonstruksjon && steps.push(DetailingStep.Takkonstruksjon);
  detaljeringssteg?.gulv && steps.push(DetailingStep.Gulv);
  detaljeringssteg?.ytterdorer && steps.push(DetailingStep.Ytterdorer);
  detaljeringssteg?.lekkasjetall && steps.push(DetailingStep.Lekkasjetall);
  detaljeringssteg?.solceller && steps.push(DetailingStep.Solceller);

  // Parameters only available for experts
  userHasBygningsekspertRole(user) && steps.push(RegistrationCommonStep.PARAMETERS);

  // Registration flow always ends with sharing consent, summary and energy certificate
  steps.push(RegistrationCommonStep.SHARING_CONSENT, RegistrationCommonStep.SUMMARY);

  return steps;
};
